<template>
	<section v-show="isActive" :aria-hidden="!isActive ? true : null" class="tab-panel h-100" role="tabpanel">
		<slot></slot>
	</section>
</template>

<script>
	export default {
		name: 'stab-item',
		props: {
			id: { type: String, required: true },
			name: { type: String, required: true },
			isDisabled: { default: false }
		},

		data() {
			return {
				isActive: false,
				isVisible: true
			}
		},
		mounted() {
			this.$parent.tabs.push(this)
		},
	}
</script>

<style lang="less" scoped>
	.tab-panel {
		height: 100%;
		overflow-y: auto;
	}
</style>
